function reciverCurrency() {
    let currencySelectParentList = document.querySelectorAll('.reciver-currency-select-dropdown');
    
    if (currencySelectParentList.length > 0) {
        const senderCurrency = currencySelectParentList[0].getAttribute('data-currency');
        const senderCountry = currencySelectParentList[0].getAttribute('data-country');

        let isBrandRefresh = checkBrandRefresh(currencySelectParentList[0])
        const requestPayload = {
            country: currencySelectParentList[0].getAttribute('data-country'),
            language: currencySelectParentList[0].getAttribute('data-language'),
            host: currencySelectParentList[0].getAttribute('data-host')
        }        

        const getCountryListConfig = triggerCountryList(requestPayload);
        const headers = {
            'content-type': 'application/JSON'
        }
        
        document.addEventListener("priceCorridorReady", ({detail: {dcaasResponse: response}}) => {
          try {
            let countryList = response.COUNTRY_LIST;

            let topCountryList = response.TOP_COUNTRIES;

            const countries = countryCurrencyDefaults.countries;
            let topEntries = [],
              countryListRefactored = [],
              remaningCountyList = [];

            for (let cindex in topCountryList) {
              if (cindex !== "listPath" && topCountryList[cindex]) {
                const listVal = topCountryList[cindex];
                const value = Object.values(listVal)[0];
                const currency = countries.find(
                  (currencies) =>
                    currencies.country.isoCode === Object.keys(listVal)[0]
                );
                
                if(currency) {
                    countryListRefactored.push({
                      value: value,
                      code: Object.keys(listVal)[0],
                      currency: currency.country.currencies,
                    });
                    topEntries.push(value);
                }
              }
            }
            countries.forEach((country) => {
              const isoCode = country.country.isoCode;
              const currency = country.country.currencies;
              const countryListValue = country.country.name;
              let countryCodeLowerCase = isoCode.toLowerCase();
              const senderCountryCheck = validateExceptionList(senderCountry,countryCodeLowerCase); 
              if (
                countryListValue &&
                (senderCountryCheck) &&
                topEntries.indexOf(countryListValue) === -1
              ) {
                remaningCountyList.push({
                  code: isoCode,
                  value: countryListValue,
                  currency: currency,
                });
                flagSelectService.sortValues(remaningCountyList, true);
              }
            });

            remaningCountyList.forEach((isoCountry) => {
              countryListRefactored.push({
                code: isoCountry.code,
                value: isoCountry.value,
                currency: isoCountry.currency,
              });
            });

            let topEntriesLength = topEntries.length;
            let receiverlist = countryListRefactored;
            // create document fragment
            let list = document.querySelectorAll(".reciver-currency-list"); // Two Component with Same Class
            list.forEach((listelementID) => {
              let fragment = document.createDocumentFragment();
              let index = 0;
              receiverlist.forEach((country_code) => {
                if (
                  ISO_CODES_COUNTRIES_CURRENCIES[country_code.code] !==
                  undefined
                ) {
                  const flagLowerCase = country_code.code.toLowerCase();
                  const currency = country_code.currency;
                  currency.forEach((currencies) => {
                    let currencyCode = currencies.currency.isoCode;
                    let li = document.createElement("li");
                    li.className = isBrandRefresh
                      ? "wuds-dropdown__items b-flag-select__item"
                      : "wuds-dropdown__item";
                    li.setAttribute("data-currencycode", currencyCode);
                    li.setAttribute("data-countrycode", country_code.code);
                    let atag = document.createElement("a");
                    atag.className = isBrandRefresh
                      ? "wuds-dropdown__item__text w-100 d-flex text-decoration-none"
                      : "wuds-dropdown__item__text";
                    atag.setAttribute("role", "menuitem");
                    atag.setAttribute("href", "javascript:void(0)");
                    atag.setAttribute("data-currencycode", currencyCode);
                    atag.setAttribute("data-countrycode", country_code.code);
                    let spanFlag = document.createElement("span");
                    spanFlag.className = isBrandRefresh
                      ? "wuds-dropdown__item-text b-flag-select__text w-100 overflow-hidden font-body-01 text-black d-flex align-items-center"
                      : "b-flag-select__text w-100 overflow-hidden font-body-sm";
                    spanFlag.setAttribute(
                      "data-countrycode",
                      country_code.code
                    );
                    spanFlag.setAttribute("title", currencyCode);
                    spanFlag.setAttribute("data-currencycode", currencyCode);

                    spanFlag.innerText =
                      currencyCode + " - " + country_code.value;
                    li.appendChild(atag);
                    let iconTag = document.createElement("i");
                    iconTag.className = isBrandRefresh
                      ? `wu-flag ${flagLowerCase} wu-flagSize--S`
                      : `wu-flag ${flagLowerCase} flag__1x1 wu-flag__rnd wu-flag__dd wu-input--flag__icon__left bdr-clr-idel bdr-thin-all bdr-radius-cir position-absolute`;
                    if (isBrandRefresh) {
                      atag.appendChild(iconTag);
                      atag.appendChild(spanFlag);
                    } else {
                      atag.appendChild(spanFlag);
                      atag.appendChild(iconTag);
                    }

                    if (topEntriesLength - 1 === index) {
                      if (isBrandRefresh) {
                        li.classList.add("wuds-dropdown__bordered-item--items");
                      } else {
                        li.classList.add("position-static");
                        iconTag.classList.add("mar-xs-lt");
                      }
                    }
                    fragment.appendChild(li);
                  });
                  index++;
                }
              });
              listelementID.appendChild(fragment);
            });
          } catch (e) {
            console.log(
              `Country list is empty fo ${requestPayload.country}-${requestPayload.language}`
            );
            console.error(e);
          }
        });
    }
}

function checkBrandRefresh(el){
    let brandRefresh = el?.getAttribute('data-brand-refresh');
    let isBrandRefresh = ((brandRefresh === '') || (brandRefresh === null) || (brandRefresh === undefined)) ? false :true; 
    return isBrandRefresh
}

function clearSearch(event,liclass){
  const currencyList = event.currentTarget.closest("#currencydropdown").querySelectorAll(liclass);        
  const inputSearch =  document.querySelector("#searchInput");
  inputSearch && inputSearch.onfocus();
  inputSearch ? inputSearch.value = "" : undefined;
  for (let i = 0; i <= currencyList.length - 1; i++) {
      currencyList[i].style.display = 'block';
  }
}

function searchFilter(event,liclass,iconSearchClass) { 
  const currencyList = event.currentTarget.closest("#currencydropdown").querySelectorAll(liclass);  
  event && event.currentTarget.value.length > 0 ? event.currentTarget.parentElement.querySelector(iconSearchClass).style.display = 'flex' : event.currentTarget.parentElement.querySelector(iconSearchClass).style.display = 'none' ; 
  if ( currencyList && currencyList.length > 0) {
      for ( let i=0; i<currencyList.length; i++) {
          let currency = currencyList[i]
          let title = currency && currency.querySelector(".b-flag-select__text").innerText;
          event && event.currentTarget &&
          title.toUpperCase().indexOf(event && event.currentTarget.value.toUpperCase()) > -1 ? currency.style.display = 'block' : currency.style.display = 'none';
      }
  }
}